import { HelperResult, StudentCredential } from '@openclassrooms/sdk-web';

import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

const { useGet: useStudentCredentials } = getCRUDHooks({
  entityName: 'studentCredentials',
  get: ({ userId }): HelperResult<StudentCredential[]> =>
    clientApi.getOCClient().helpers.user.users.id(userId).studentCredentials.find(),
});

export {
  // eslint-disable-next-line import/prefer-default-export
  useStudentCredentials,
};
